import ForgotPasswordForm from "../../components/Auth/ForgotPasswordForm";
import Creator from "../../components/CreatorTools/CreatorTools";
import GluedInLogin from "../../components/GluedInLogin/GluedInLogin";
import Series from "../../components/Series/Series";
import SoundTrack from "../../components/VerticalPlayer/components/SoundTrack";
import ActivityTimeline from "../../pages/ActivityTimeline";
import CoinWallet from "../../pages/CoinWallet";
import ContentDetailPage from "../../pages/ContentDetail";
import ContinueWatching from "../../pages/ContinueWatching";
import CreateContent from "../../pages/CreatePost";
import CreateContentStepTwo from "../../pages/CreatePostStepTwp";
import CreateTextContent from "../../pages/CreateText";
import Discover from "../../pages/Discover";
import DiscoverContent from "../../pages/DiscoverContent";
import EarnCoins from "../../pages/EarnCoins";
import HashtagDetail from "../../pages/HashtagDetail";
import Landing from "../../pages/Landing";
import Login from "../../pages/Login";
import MyProfile from "../../pages/MyProfile";
import Notification from "../../pages/Notification";
import Profile from "../../pages/Profile";
import SearchFilter from "../../pages/searchFilter";
import Signup from "../../pages/Signup";
import StoryView from "../../pages/StoryView";
import Support from "../../pages/support";
import SupportIssueDetails from "../../pages/SupportIssueDetails";
import SupportReport from "../../pages/SupportReport";
import Transactions from "../../pages/Transactions";
import React from "react";
import { Navigate, RouteObject } from "react-router-dom";
import AppShell from "../layouts/AppShell";
import FeedEntryRoute from "./FeedEntryRoute";
import ProtectedFallback from "./ProtectedFallback";

export const appRoutes: RouteObject[] = [
  {
    path: "/",
    element: <AppShell />,
    children: [
      {
        index: true,
        element: <Landing />,
      },
      {
        path: "vertical-video",
        element: <Navigate to="/feed" replace={true} />,
      },
      {
        path: "post",
        element: (
          <Navigate to="/feed" state={{ templateType: "POST" }} replace={true} />
        ),
      },
      { path: "sign-up", element: <Signup /> },
      { path: "sign-in", element: <Login /> },
      { path: "discover", element: <Discover /> },
      { path: "discover/content", element: <DiscoverContent /> },
      { path: "discover/series/:seriesId", element: <Series /> },
      { path: "activity-timeline", element: <ActivityTimeline /> },
      { path: "notification", element: <Notification /> },
      { path: "profile/:userId", element: <Profile /> },
      { path: "my-profile", element: <MyProfile /> },
      { path: "create-post", element: <CreateContent /> },
      { path: "create-post-page-02", element: <CreateContentStepTwo /> },
      { path: "content/:contentId", element: <ContentDetailPage /> },
      { path: "hashtag/:hashtagName", element: <HashtagDetail /> },
      { path: "earn-coins", element: <EarnCoins /> },
      { path: "coin-wallet", element: <CoinWallet /> },
      { path: "coin-wallet/transactions", element: <Transactions /> },
      { path: "support", element: <Support /> },
      { path: "support/report", element: <SupportReport /> },
      { path: "support/issue/:ticketId", element: <SupportIssueDetails /> },
      { path: "create-text", element: <CreateTextContent /> },
      { path: "search-filter", element: <SearchFilter /> },
      { path: "forgot-password", element: <ForgotPasswordForm /> },
      {
        path: "vertical-player",
        element: <Navigate to="/feed" replace={true} />,
      },
      { path: "sound-track/:soundId", element: <SoundTrack /> },
      { path: "feed", element: <FeedEntryRoute /> },
      { path: "gluedin-login", element: <GluedInLogin /> },
      { path: "creator", element: <Creator /> },
      { path: "story-view/:userId", element: <StoryView /> },
      { path: "series/:seriesId", element: <Series /> },
      { path: "watchlist", element: <ContinueWatching /> },
      {
        path: "*",
        element: <ProtectedFallback />,
      },
    ],
  },
];
